import { render, staticRenderFns } from "./ticketLog.vue?vue&type=template&id=bf85f788&scoped=true"
import script from "./ticketLog.vue?vue&type=script&lang=js"
export * from "./ticketLog.vue?vue&type=script&lang=js"
import style0 from "./ticketLog.vue?vue&type=style&index=0&id=bf85f788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85f788",
  null
  
)

export default component.exports